// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__1OW-J","fileBtn":"File_fileBtn__1TK3X","closeBtn":"File_closeBtn__1WjlI","fileSelected":"File_fileSelected__10kVx","disabled":"File_disabled__3fxWW"};